import $ from 'jquery';
import Flickity from 'flickity';


let sliders = {


    init(){
        if( !$('.slider').length ){ return; }
        $('.slider').each( (index, el) => {
            var $this = $(el);
            var flkty = new Flickity( el, {
                pageDots: false,
                prevNextButtons: true,
                on: {
                    ready: () => {
                        $this.css('opacity','1');
                    }
                } 
            });
        });
    },

    initWrapAround(){
        if( !$('.slider-wrap').length ){ return; }
        $('.slider-wrap').each( (index, el) => {
            var $this = $(el);
            var flkty = new Flickity( el, {
                pageDots: false,
                wrapAround: true,
                prevNextButtons: true,
                on: {
                    ready: () => {
                        $this.css('opacity','1');
                    }
                } 
            });
        });
    },

    initSliderContain(){
        if( !$('.slider-contain').length ){ return; }
        $('.slider-contain').each( (index, el) => {
            var $this = $(el);
            var flkty = new Flickity( el, {
                pageDots: false,
                contain: true,
                prevNextButtons: true,
                on: {
                    ready: () => {
                        $this.css('opacity','1');
                    }
                } 
            });
        });
    },

    initHeroSlider(){
        if( !$('.slider-hero').length ){ return; }
        $('.slider-hero').each( (index, el) => {
            var $this = $(el);
            var flkty = new Flickity( el, {
                pageDots: false,
                freeScroll: true,
                wrapAround: true,
                prevNextButtons: true,
                on: {
                    ready: () => {
                        $this.css('opacity','1');
                    }
                } 
            });
        });
    }

}
export default sliders;